import SvgIcon, { SvgIconProps } from '@eversports/react-components/primitives/SvgIcon'

const ArrowRightIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 13 10" fill="none" {...props}>
    <path
      d={
        'M11.8359 4.94531L7.89844 8.88281C7.6875 9.09375 7.33594 9.09375 7.10156 8.88281C6.89062 8.67188 6.89062 ' +
        '8.29688 7.10156 8.08594L10.0781 5.10938H0.5625C0.257812 5.10938 0 4.85156 0 4.54688C0 4.24219 0.257812 ' +
        '3.98438 0.5625 3.98438H10.0781L7.10156 1.00781C6.89062 0.796875 6.89062 0.421875 7.10156 0.210938C7.3125 ' +
        '0 7.6875 0 7.89844 0.210938L11.8359 4.14844C12.0469 4.35938 12.0469 4.73438 11.8359 4.94531Z'
      }
      fill="currentColor"
    />
  </SvgIcon>
)

export default ArrowRightIcon
